import { render, staticRenderFns } from "./AdminAssociations.vue?vue&type=template&id=12d15e43"
import script from "./AdminAssociations.vue?vue&type=script&lang=js"
export * from "./AdminAssociations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports